export default "__VITE_ASSET__yk$XK3TE__"